import React, { useEffect, useMemo } from 'react';
import _ from 'lodash';
import TabContainer from '../../../../../../../../common/components/tab/containers/tab.containers';
import AccountUserBasicInfoComponent from './account-user-basic-info.component';
import { useSelector } from 'react-redux';
import { selectAccountsListItems, selectAccountsQueryItems } from '../../../../../../../../redux/accounts/selector';
import { toast } from "react-toastify";
import { AddressContainer } from '../../../../../../../../common/address/containers/address.container';

export const AccountUserComponent = ({
    selectedAccountUsers,
    handleInnerFormChange,
    selectedAddress,
    handleInnerAddressFormChange,
    handleFormSubmit,
    back,
    id,
    accountTypesList
}: any) => {

    const accountListItems = useSelector(selectAccountsQueryItems);
    // extract boolean safely
    const isPersonAccount = accountListItems?.result?.items?.AccountInfo?.IsPersonAccount;

    // show error msg only when true
    useEffect(() => {
        if (isPersonAccount === true) {
            toast.error("Person account enabled so not able to add user");
        }
    }, [isPersonAccount]);

    // Tabs visible only when IsPersonAccount is false
    const tabItems = useMemo(() => [
        {
            id: 1,
            title: 'User Information',
            component: (
                <AccountUserBasicInfoComponent
                    id={id}
                    handleInnerFormChange={handleInnerFormChange}
                    selectedAccountUsers={selectedAccountUsers}
                    accountTypesList={accountTypesList}
                />
            ),
            isVisible: isPersonAccount === false
        },
        {
            id: 2,
            title: 'User Address',
            component: (
                <AddressContainer
                    onInnerFormChange={handleInnerAddressFormChange}
                    selectedAddress={selectedAddress}
                />
            ),
            isVisible: isPersonAccount === false
        },
    ], [isPersonAccount]);

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            {/* Tabs displayed only when IsPersonAccount === false */}
            {isPersonAccount === false ? (
                <TabContainer tabItems={tabItems} />
            ) : (
                <div className="text-red-600 font-semibold my-5">
                    Person account is enabled — You cannot add user.
                </div>
            )}

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>

                {/* Disable Save Button when IsPersonAccount === true */}
                <button
                    disabled={isPersonAccount === true}
                    className={`m-2 rounded font-medium px-4 py-3 text-white 
                        ${isPersonAccount === true ? "bg-gray-400" : "bg-blue-700"}`}
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default AccountUserComponent;
